import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_321: DocMigration = {
  maxSchemaVersion: "0.0.321",
  description: "Set entity type & id for Preset",
  apply(json: any) {
    for (const id in json.presets) {
      json.presets[id] = {
        ...json.presets[id],
        id,
        entityType: "PRESET",
      };
    }

    return json;
  },
};

export default migration_0_0_321;
